import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('invites');

actions.readFromToken = token => {
  const read = actions.read();
  const { payload } = read;

  return {
    ...read,
    payload: {
      ...payload,
      url: `${payload.url}/${token}`,
    },
  };
};
